import React, { forwardRef, useEffect, useRef, useState } from 'react'
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { Alert, AnimatedCircleStatus, Button, Checkbox, Container, CustomSelect, Input, InputWrapper, Main, PageHeader, Textarea, Timeline } from '../../../Components';

import './../incidents.css'
import toast from 'react-hot-toast';
import { useConfirmationModal } from '../../../Hooks/useNotifications';
import { Helmet } from 'react-helmet';
import { componentStatus, incidentImpact, incidentStatus } from '../../../Constants/Constants';
import { ReactComponent as OperationalIcon } from './../../../assets/icons/component_status_operational.svg';

import {BsFillUnlockFill , BsFillLockFill} from 'react-icons/bs'
import "flatpickr/dist/themes/material_orange.css";
import Flatpickr from "react-flatpickr";
import { useSelector } from 'react-redux';
import {AiOutlineMinusSquare, AiOutlinePlusSquare} from 'react-icons/ai'
import {calculateComponentGroupStatus} from '../../../Helpers/status'

export function EditIncident() {

	const { page_id , incident_id } = useParams();
	const navigate = useNavigate();
	const effectCalled = useRef(false)
	const { getConfirmation } = useConfirmationModal();
	const { user , org } = useSelector((state) => state.auth)

	const [formData, setFormData] = useState({
		id : null ,
		name: "",
		description: "",
		descriptionPlaceholder : "We are currently investigating this issue.",
		status : "INVESTIGATING",
		impact : 'NONE',
		isLockedImpact : true,
        notify_subscribers : false
	});
	const [formValidation, setFormValidation] = useState({
		name : "",
		description : "",
		components : "",
	})

	const [isLoadingIncidentData, setIsLoadingIncidentData] = useState(false)
	const [isLoadingComponents, setIsLoadingComponents] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [components, setComponents] = useState([])
	const [incidentData, setIncidentData] = useState({})
	const [showForm, setShowForm] = useState(false)
	const [isEditForm, setIsEditForm] = useState(false)
	const [showEditingIncidentName, setShowEditingIncidentName] = useState(false)
	const [isSavingIncidentName, setIsSavingIncidentName] = useState(false)

	useEffect(() => {

		if(effectCalled.current){ return ;}
		 
		async function fetchData() {
			 // ! CHECK THE ACCESS 
			if(org?.statuspages?.findIndex(x => x.id === page_id) < 0 ) {
				navigate(`/pages`)
				return
			}
			
			await getIncidentData();
		}
		fetchData();

		effectCalled.current = true ;
	  
	}, [])

		/**
	 * 
	 * @returns 
	 */
	const getIncidentData = () => {

		return new Promise(async(resolve, reject) => { 

			setIsLoadingIncidentData(true)
			
			
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = { }

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/incidents/${incident_id}` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( async data => {

					setIncidentData(data)
					setFormData( (prevState) => ({ 
						...prevState,
						name: data?.name,
						status : (data?.updates ?? [])[0]?.status ?? formData?.status,
						description : (data?.updates ?? [])[0]?.description ?? formData?.description,
						date : new Date((data?.updates ?? [])[0]?.updated_at) ?? new Date(Date.now),
						impact : data?.impact,
						isLockedImpact : data?.is_locked_impact
					}))

					// ! Check if the incident not have any updates, than we should get the components list like the New incident form 
					if(data?.updates===null || data?.updates.length <=0 ){

						await getComponents({
							page : 0,
							per_page : -1
						})
					}else{

						// ! Else we save the components of the last update
						// Mark the components that already affected from the last update 
						setComponents((data?.updates ?? [])[0]?.components?.map( prevElement => ({
							...prevElement,
							status : componentStatus.find( x => x.value === prevElement.status)
						})))
					}

					// Mark the components that already affected from the last update 
					// const lastUpdateComponents =  (data?.updates ?? [])[0]?.components?.map( prevElement => ({
					// 	...prevElement,
					// 	status : componentStatus.find( x => x.value === prevElement.status)
					// }))  
					 
					// setComponents(lastUpdateComponents)
					 

					setIsLoadingIncidentData(false)
		
					resolve(data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/signout')
					}
					setIsLoadingIncidentData(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							setIncidentData({})
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}
				})
			}else{
				setIsLoadingIncidentData(false)
			}

		})
	} 


	const onChangeStatus = (event) => {
	 
		const selectedStatus =  event.currentTarget.dataset.status
		const placeholder =  event.currentTarget.dataset.status_desc_placeholder
		setFormData( (prevState) => ({
			...prevState,
			status : selectedStatus,
			descriptionPlaceholder : placeholder,
			description : placeholder

		})) 

	}

	/**
	 * 
	 * @param {*} e 
	 * @returns 
	 */
	// const onChangeName = (e) => setFormData( prevState => ({ ...prevState , name : e.target.value }))
	const onChangeInputs = (e) => {
		switch(e.target.name){
			case "name" : 
				setFormValidation((prevState) => ({
					...prevState,
					name : (e.target.value === '') ? 'Invalid name' : ''
				}))
				
				break;
			
		}

		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: (e.target.type ==='checkbox') ? e.target.checked :  e.target.value,
		}));
	}

	/**
	 * 
	 * @param {*} e 
	 */
	const onChangeAffectedComponents = (e , _component_id) => {
		let _components = [...components]
		const index = _components.findIndex( x=> x.id === _component_id)
		_components[index].is_affected = e.target.checked
		setComponents(_components) 

		setFormValidation( prevState => ({
			...prevState ,
			components : _components.filter(x=>x.is_affected === true).length <= 0 ? "No component affected for this incident!" : ''
		}))
		
	}

	/**
	 * 
	 * @param {*} e 
	 * @param {*} _component_id 
	 */
	const onChangeAffectedComponentsStatus = (value , _component_id) => {
		let _components = [...components]
		const index = _components.findIndex( x=> x.id === _component_id)
		_components[index].status = value
		setComponents(_components) 

		 
		
	}
 
	const selectAllComponents = () => {
		
		let _components = [...components]
		_components = _components.map( item => ({...item, is_affected : true }))
		setComponents(_components)
		
		setFormValidation( prevState => ({
			...prevState ,
			components : _components.filter(x=>x.is_affected === true).length <= 0 ? "No component affected for this incident!" : ''
		}))
	}

	const deselectAllComponents = () => {
		
		let _components = [...components]
		_components = _components.map( item => ({...item, is_affected : false }))
		setComponents(_components) 

		setFormValidation( prevState => ({
			...prevState ,
			components : _components.filter(x=>x.is_affected === true).length <= 0 ? "No component affected for this incident!" : ''
		}))
	}

	const onSubmit = async (e) => {
		e.preventDefault();

		return new Promise( async (resolve, reject) => { 
			
			setIsLoading(true)
			const affectedComponents = components.filter(x => x.is_affected === true)
			setFormValidation((prevState) => ({
				...prevState,
				// name: (formData.name === '') ? "Name can't be blank." : '',
				components : affectedComponents?.length <=0 ? "No component affected for this incident!" : ''
			}))

			if(affectedComponents?.length <= 0 ){

				toast.error("Please complete all required fields") 
				setIsLoading(false)

				return 
			}

			
			
			
			
			
			if (user && user.token && org && org?.id ) {

				
				let params = { 
					description : formData?.description,
					components : components.map( (prevElement) => ({
						...prevElement , 
						status : prevElement?.status?.value
					})),//.filter( x=> x.is_affected === true),
					status : formData?.status,
				}
                if(!isEditForm) { // add a new incident update 
                    params.notify_subscribers = formData?.notify_subscribers
                }   

				const token = user?.token;


				await axios.post(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/incidents/${incident_id}/updates`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

					setIsLoading(false)

					setIncidentData( prevState => ({
						...prevState,
						updates : [ data?.update  , ...prevState.updates ?? []]
					}));

					toast.success("Your update has been successfully created")  
					
					
					setFormData( prevState => ({
						...prevState ,
						description : "",
						impact : data?.incident?.impact ? data?.incident?.impact : formData?.impact 
					})) 

					 
		
					resolve(data.data) 
		
				})
				.catch(error => {
					let __error = "Something went wrong. thank you try later.";
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						__error = ((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							__error = "Something went wrong. thank you try later.";
						}
					}

					toast.error(__error)  
					reject(__error) 
				})
			}else{
				setIsLoading(false)
				toast.error("Something went wrong, please try again later.")
			}


		})

	}

	/**
	 * 
	 * @param {*} e 
	 * @returns 
	 */
	const onSubmitUpdate = async (e) => {
		e.preventDefault();

		return new Promise( async (resolve, reject) => { 
			
			setIsLoading(true)
			const affectedComponents = components.filter(x => x.is_affected === true)
			setFormValidation((prevState) => ({
				...prevState,
				// name: (formData.name === '') ? "Name can't be blank." : '',
				components : affectedComponents?.length <=0 ? "No component affected for this incident!" : ''
			}))

			if(affectedComponents?.length <= 0 ){

				toast.error("Please complete all required fields") 
				setIsLoading(false)

				return 
			}

			
			
			
			
			
			if (user && user.token && org && org?.id && formData?.id !==null ) {

				
				let params = { 
					description : formData?.description,
					components : components.map( (prevElement) => ({
						...prevElement , 
						status : prevElement?.status?.value
					})),//.filter( x=> x.is_affected === true),
					status : formData?.status,
					date : formData?.date
				}

				const token = user?.token;


				await axios.put(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/incidents/${incident_id}/updates/${formData?.id}`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

					setIsLoading(false)

					let _incidentData = incidentData//{...incidentData}
					const index = _incidentData?.updates?.findIndex( x => x.id === formData?.id )
					_incidentData.updates[index] = data?.update




					setIncidentData( prevState => ({
						...prevState,
						updates : _incidentData?.updates
					}));

					if (data?.incident?.impact ){
						setFormData( prevState => ({
							...prevState,
							impact : data?.incident?.impact
						}))
					}

					toast.success('Your update has been successfully edited') 

					 

					 
		
					resolve(data.data) 
		
				})
				.catch(error => {


					let __error = "Something went wrong. thank you try later.";
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						__error = ((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							__error = "Something went wrong. thank you try later.";
						}
					}

					toast.error(__error)  
					reject(__error)  
				})
			}else{
				setIsLoading(false)
				toast.error("Something went wrong, please try again later.")
			}


		})

	}

	/**
	 * 
	 * @param {*} params 
	 */
	const openModal_deleteIncidentUpdate = (params) => {

		 
		getConfirmation({
			size : 'small',
			type: 'danger',
			title: "Deleting incident updates",
			message: "Are you sure you want to delete this update? ",
			labels: { confirm: 'Delete update', cancel: "No don't delete it" },
			onConfirm : () => {
				deleteIncidentUpdate(params?.incident_update_id)
			},
			onCancel : () => {
				 

			}
		});


		 
	}

	/**
	 * 
	 * @param {*} INCIDENT_UPDATE_ID 
	 * @returns 
	 */
	const deleteIncidentUpdate = (INCIDENT_UPDATE_ID) => {

		return new Promise( async (resolve, reject) => { 
			
			// setIsLoading(true)
			 

			
			
			
			
			
			if (user && user.token && org && org?.id ) {
				 

				const token = user?.token;


				await axios.delete(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/incidents/${incident_id}/updates/${INCIDENT_UPDATE_ID}`, {
					params : {},
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

					
					let _incidentData = {...incidentData};
					_incidentData.updates = _incidentData?.updates?.filter((p) => p.id !== INCIDENT_UPDATE_ID);
					setIncidentData(_incidentData)

					if (data?.incident?.impact ){
						setFormData( prevState => ({
							...prevState,
							impact : data?.incident?.impact
						}))
					}
					 
 
					toast.success('Your incident update has been successfully deleted')

					// components list 
					resolve(data.data)  
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/signout')
					}
					// setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.error('Something went wrong, please try again later.') 
				})
			}else{
				// setIsLoading(false)
				toast.error('Something went wrong, please try again later.')  
			}


		})
	}

	/**
	 * 
	 * @param {*} params 
	 */
	const editIncidentUpdate = (params) => {

		
		setShowForm(true)
		setIsEditForm(true)
		// Fill the main form : Fill the date from IncidentData.updates to formData 
		const updateData = {...incidentData}?.updates.find( x => x.id === params?.incident_update_id)
		setFormData( prevState => ({
			...prevState ,
			id : updateData?.id , 
			description : updateData?.description,
			status : updateData?.status,
			date : new Date(updateData?.updated_at)
		}))

	 
		 
		setComponents( updateData?.components.map( prevElement => ({
			...prevElement,
			status : componentStatus.find( x => x.value === prevElement.status)
		})))

	}

	/**
	 * 
	 */
	const openForm_newIncidentUpdate = async () => {
		setShowForm(true)
		setIsEditForm(false)

		const _incidentData = {...incidentData}

		setFormData( (prevState) => ({ 
			...prevState,
			id : null ,
			name: _incidentData?.name,
			status : (_incidentData?.updates ?? [])[0]?.status ?? formData?.status,
			description : (_incidentData?.updates ?? [])[0]?.description ?? formData?.description
		}))

		// ! Check if the incident not have any updates, than we should get the components list like the New incident form 
		if(_incidentData?.updates===null || _incidentData?.updates.length <=0 ){

			await getComponents({
				page : 0,
				per_page : -1
			})
		}else{

			// ! Else we save the components of the last update
			// Mark the components that already affected from the last update 
			setComponents((_incidentData?.updates ?? [])[0]?.components?.map( prevElement => ({
				...prevElement,
				status : componentStatus.find( x => x.value === prevElement.status)
			})))
		}



	}

	/**
	 * 
	 * @returns 
	 */
	const editIncidentName = () => {
		

		return new Promise( async (resolve, reject) => { 
			
			setIsSavingIncidentName(true)
			setFormValidation((prevState) => ({
				...prevState,
				name: (formData.name === '') ? "Name can't be blank." : '',
			}))

			if(formData?.name  === '' ){

				toast.error("Please complete the incident name") 
				 
				setIsSavingIncidentName(false)

				return 
			}

			
			
			
			
			
			if (user && user.token && org && org?.id   ) {

				
				let params = { 
					name : formData?.name,
				 
				}

				const token = user?.token;


				await axios.put(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/incidents/${incident_id}`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

					setIsSavingIncidentName(false)

					
					toast.success('Your incident name has been successfully updated')  
					 

					setShowEditingIncidentName(false)

					resolve(data.data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/signout')
					}
					setIsSavingIncidentName(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.error('Something went wrong, please try again later.') 
				})
			}else{
				setIsSavingIncidentName(false)
				toast.error('Something went wrong, please try again later.') 
			}


		})

	}

	/**
	 * @props : { id , state_id , value , wSuccessMessage = true }
	 * @returns 
	 */
	const editInstantly_incident = (props) => {


		setFormData( prevState => ({
			...prevState ,
			[props.state_id] : (props.state_id === 'isLockedImpact') ? props?.value?.value :  props?.value 
		})) 
		

		return new Promise( async (resolve, reject) => { 
			
			let error_message = null 
			if(props.id ==='impact'){
				
				const index = incidentImpact.findIndex( x => x.value === props?.value?.value)
				if( index < 0 ) error_message = "Please choose the incident impact from the list"
			}	
			if( error_message ){

				toast.error(error_message) 

				return 
			}

			
			
			
			
			
			if (user && user.token && org && org?.id   ) {

				
				let params = { 
					[props.id] : props?.value?.value,
				 
				}

				const token = user?.token;


				await axios.put(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/incidents/${incident_id}`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {


					
					if(params.wSuccessMessage === false )
						toast.success( 'Your incident data has been successfully updated') 

					setShowEditingIncidentName(false)

					resolve(data.data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/signout')
					}
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.success( 'Something went wrong, please try again later.') 
					
				})
			}else{
				toast.success( 'Something went wrong, please try again later.') 
			}


		})

	}

	/**
	 * 
	 * @param {*} param0 
	 * @returns 
	 */
	const getComponents = async ({ page , per_page}) => {

		return new Promise(async(resolve, reject) => { 

			setIsLoadingComponents(true)
			
			
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = {
					page : page ,
					per_page : per_page,
					 
				}

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/components` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					 

					setComponents(data.data.map( item => ({
						id : item?.id,
						name : item?.name ,
						description : item?.description ,
						is_affected : false ,
						status : {
							value : "OPERATIONAL",
							label : 'Operational',
							icon : <OperationalIcon fill="white" color="#2fcc66"/>,
						}
					})))

					setIsLoadingComponents(false)
		
					resolve(data.data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/signout')
					}
					setIsLoadingComponents(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							setComponents([])
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
								reject(`Something went wrong. Thank you try later.`)
						}
					}
				})
			}else{
				setIsLoadingComponents(false)
			}

		})
	}

	/** COMPONENT */
	const AffectedComponents = ({ }) => {
		return (
			isLoadingIncidentData === true 
				? 'loading ... '//<SkeletonAffectedComponent />
				: (
					components?.length <=0 
					? <div>
						<div className="noitems_title">No components to display</div>
						<div className="noitems_subtitle">The components of your website or application are the parts that allow it to function correctly. You can add some components here to view them.</div>
						<Link 
							className={`btn btn-purple`}
							to={`/pages/${page_id}/components/new`}
							>Add component</Link>
					</div>
					: <>
						{
							[...(components ?? [])].filter(x => x.is_affected === true ).length  === [...(components ?? [])].length 
								? <Button link={true} onClick={deselectAllComponents}>Select none</Button>	
								: <Button link={true} onClick={selectAllComponents}>Select all</Button>	
						}	
						{
							renderComponents({
								id: 'root',
								name: null,
								is_group: false,
								children: components.filter(x => x.group_id === null)
							})
						}
					</>
				)
		)
	}

	const AffectedComponentItem = ({ list , level , children  }) => {

		const [isOpen, setIsOpen] = useState(true)

		const groupStatus = calculateComponentGroupStatus(list?.children)
		const componentGroupStatusContent = componentStatus?.find( x => x.value === groupStatus )

		return (
			<div className={`${level === 0 ? 'component-items' : 'components-group'}`} >
				 
				{
					list.id !=='root' && 
					<div className='component-item'  onClick={() => setIsOpen(!isOpen)} >
						<div className="component-wrapper">
							<div className="component-group-icon" >
								{ isOpen === true 
									? <AiOutlineMinusSquare />
									: <AiOutlinePlusSquare />
								}
							</div>
							<div className="component-name">{list?.name}</div>
							<div className={`component-status ${componentGroupStatusContent?.color_name}`}>{componentGroupStatusContent?.label}</div>   
				
						</div>
					</div>
				}
				<div className={`children ${isOpen === true  ? 'opened' : ''}`}>
					{ children  }
				</div>
			</div>

		)
	}

	const renderComponents = (list , level = 0 ) => {

		const groupStatus = calculateComponentGroupStatus(list?.children)
		const componentGroupStatusContent = componentStatus?.find( x => x.value === groupStatus )
	
		return (
			<AffectedComponentItem 
				list={list}
				level={level}
				>
					{
						list?.children?.map( ( component , index) => {

						 

							const componentStatusContent = componentStatus?.find( x => x.value === component?.status )
							return (
								component.is_group === false 
								? <div key={index} className="component-item ">
									<div className="component-wrapper">
										<div className='component-info'>
											<Checkbox 
												label={component?.name}
												checked={component?.is_affected}
												onChange={(e) => onChangeAffectedComponents(e , component?.id)}
											/>
											<div className='component-desc'>{component?.description?.length > 70 ? component?.description?.substr(0 , 75)+'...' : component?.description}</div>												
										</div>
										<div className='component-status'>
											<div className='component-status-wrapper'>
												{
													component?.is_affected === true && 
													<CustomSelect
														data={
															componentStatus?.map( item => ({
																value : item?.value ,
																label : item?.label ,
																icon : item?.icon
															}))
														}
														onChange={(value) => onChangeAffectedComponentsStatus(value , component?.id)}
														name={`afcomp-${component?.id}`}
														value={componentStatus.find( x => x.value === component?.status?.value)}
														className="fluid"
														showIcons={true}
														isSearchable={false}
														
													/>
													
												}
											</div>
										</div>
									</div>											
								</div>											
								: (
									renderComponents({
										id : component?.id ,
										name : component?.name ,
										is_group : component?.is_group,
										children : components?.filter( x => component?.component_children?.includes(x?.id))
									} , level +1)
								)
							)
						})
					}
				</AffectedComponentItem>
		)
	
	}
	
	const incidentStatusList = incidentStatus
	const selectedStatus_indice = incidentStatusList.findIndex(x => x.id === formData.status) 

	const selectedStatusDetails = incidentStatus.find(x=>x.id === formData?.status)
 
	const [date, setDate] = useState(new Date())

 
	

	return (
		<>
		<Helmet>
			<title>{`Edit incident - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<Main 
			breadcrumbsItems={[
				{ name: 'Home', link: '/' },
				{ name: 'Status Pages', link: `/pages` },
				{ name: 'Incidents', link: `/pages/${page_id}/incidents` },
			]}
			 >
			<PageHeader
				title="Edit Incident"
				description={<div className="incident-form_edit-name-wrapper">
						{
							showEditingIncidentName === true 
							? <form>
								<Input
									name='name'
									placeholder=""
									required
									mb={15}
									onChange={onChangeInputs}
									error={formValidation.name}
									value={formData.name}
									variant="filled"
									suffix={
										<Button 
											link={true}
											loading={isSavingIncidentName} 
											onClick={editIncidentName} 
											mr={25} 
											color="yellow" 
											radius="xs" 
											>Save!</Button>
								}
								/></form>
							: <div 
								className={`incident-final_name`}
								order={2} 
								mb={10} 
								
								onClick={() => setShowEditingIncidentName(true)}
								>{formData.name}</div>
						}
					</div>}
					actionBtns={[
						{
							type : 'component',
							component : <form className="incident-form_edit-impact-wrapper">
								<div className="field-group">
									<label>Impact</label>
									<CustomSelect
										isDisabled={formData?.isLockedImpact }
										// className={classes.impactSelect}
										placeholder="Pick one"
										data={incidentImpact.map( item => ({
											value: item?.value , 
											label : item?.label
										}))}
										value={incidentImpact.find(x => x.value === formData?.impact)}
										onChange={(e) => editInstantly_incident({ id : 'impact' , state_id : 'impact' , value : e })}
										/>
									<Button 
										size="sm" 
										className="ml-5"
										onClick={() => {
											formData?.isLockedImpact === true 
											? editInstantly_incident({ id : 'is_locked_impact' , state_id : 'isLockedImpact' , value : {value : false} , wSuccessMessage : false })
											: editInstantly_incident({ id : 'is_locked_impact' , state_id : 'isLockedImpact' , value : { value : true } , wSuccessMessage : false })
											
										}} >
										{ 
											formData?.isLockedImpact === true 
											? <BsFillLockFill  />
											: <BsFillUnlockFill  />
										}
									</Button>
								</div>
							</form>
						}
					]}
				/>
				<div className='incident-form_edit-grid'>
					<div className={`incident-form_edit-grid_left ${showForm === false ? 'hide' : ''}`}>
						<form>
							<div className="field-group fluid event-progress-wrapper" mt={15}>
								<label htmlFor="" className="fluid">Incident status *</label>
								<div className="outer-wrapper">
									<div id="event-progress-bar">
										<div className="padding"></div>
										<div className="progress-bar">
											<span className={`progress ${formData.status.toLowerCase()}`} ></span>
										</div>
										<div className="padding"></div>
									</div>
									<div className="events">
										{
											incidentStatusList.map( (incidentStatus , index) => { 
												let isActive = index <= selectedStatus_indice  ? true: false  ;
												


												return (	
													<div 
														key={index} 
														className={`event-wrapper ${incidentStatus.name.toLowerCase()}`}  
														data-status={incidentStatus.id} 
														data-status_desc_placeholder={incidentStatus?.placeholder}
														onClick={onChangeStatus}  >
															<div className="indicator">
																<div className={`dot ${isActive === true ? 'active' : ''} ${formData.status === incidentStatus.id ? 'selected' : ''}`}></div>
															</div>
															<div className={`label ${isActive === true ? 'active' : ''} ${formData.status === incidentStatus.id ? 'selected' : ''}`}>
																<span>{incidentStatus.name}</span>
															</div>
													</div>
													)
											})
										}
									</div>
								</div>
							</div>
							<Textarea
								fluid={`true`}
								mt={15}
								placeholder={formData?.descriptionPlaceholder}
								label="Description"
								autosize
								rows={4}
								name="description"
								onChange={onChangeInputs}
								value={formData?.description}
							/>	
							{
								isEditForm === true && 
								// <Flatpickr options={{ minDate: "2017-01-01" }} />
								<div className='field-group'>
									<label htmlFor="">Date</label>
									<div className="input-wrapper">
										<Flatpickr
										data-enable-time
										value={formData?.date}
										onChange={([e]) => setFormData( prevState => ({...prevState , date : e}))}
										
									/>
										</div> 	
								</div>
								// <DateTimePicker
								// 	label="Date"
								// 	placeholder="Pick date time"
								// 	// inputFormat={"DD-MMM-YYYY hh:mm a"}
								// 	inputFormat={"dddd, MMMM D YYYY [at] hh:mm A"}
								// 	value={formData?.date}
								// 	onChange={(e) => setFormData( prevState => ({...prevState , date : e}))}
								// />
							}
                            {
                                isEditForm === false && 
                                <InputWrapper mt={15}
                                    fluid
                                    label="Notifications"
                                    
                                >
                                    <Checkbox
                                        name="notify_subscribers"
                                        label="Send notifications to the status page's subscribers"
                                        value={formData?.notify_subscribers}
                                        onChange={onChangeInputs}
                                        />
                                </InputWrapper>
                            }
							<InputWrapper mt={15}
								fluid={`true`}
								label="Affected components"
								description="The components that are currently affected or were previously affected by this incident"
								error={formValidation?.components}
								required
							>
								<AffectedComponents />
								
							</InputWrapper>
							<div className="incident-form_footer-wrapper form_fixed_footer">
								<div className="container flex-end">
									<div  className="incident-form_footer" >
										<Button color="gray" variant="default" >Back</Button>
										<Button onClick={isEditForm === true && formData?.id !==null ? onSubmitUpdate : onSubmit}  loading={isLoading}>{'Save'}</Button>
									</div>

								</div>
							</div>
						
						</form>
					</div>
					<div className={`incident-form_edit-grid_right ${showForm === false ? 'fluid' : ''}`}>
						<div className="update-history">
							<div className="update-history_title">Update History { showForm === true && <Button link={true} onClick={() => setShowForm(false)} >Show details</Button> }</div>
							<div className="update-history_content">
								{
									isLoadingIncidentData === true 
									? 'Loading...'
									: (
										incidentData?.updates=== null ||  incidentData?.updates?.length <=0
										? <Alert color="danger" variant="outline">
											No update was found, you can always add a new one by clicking on the button "Add new update"
											<Button onClick={() => openForm_newIncidentUpdate()}>Add new update</Button>
										</Alert>
										: <Timeline>
												{
													incidentData?.updates?.findIndex( x => x.status === 'RESOLVED') < 0 && 
													(

														showForm === false || isEditForm === true
														? <Timeline.Item 
																className={`incident_update-item incident_update-new`}
																// className={`${classes.incidentNewUpdateItemButton}`} 
																title={''}>
																<Button onClick={() => openForm_newIncidentUpdate()}>Add new update</Button>
															</Timeline.Item>
														: <Timeline.Item 
															className={`incident_update-item incident_update-new ${selectedStatusDetails?.status}`}
															bullet={<AnimatedCircleStatus 
																style={{ marginLeft : '-13px'}} 
																status={
																	selectedStatusDetails?.globalColor ?? 'yellow'
				
																}
															/>}
															title={'New updating ...'  }>
															<p  color="dimmed" size="sm">Please complete your new update and don't forget to save it</p>
														</Timeline.Item>
													)
													
												}
												
												{
													incidentData?.updates && incidentData?.updates.map( (update , index) => {
														return (
															<Timeline.Item 
																key={index} 
																className={`incident_update-item ${update?.id === formData?.id ? 'active' : ''}`} 
																title={incidentStatus.find(x => x.id === update?.status)?.name}
																onClick={ () => editIncidentUpdate({ incident_update_id : update?.id }) }
																>
																<div className="action-btns"  spacing="xs"  >
																	<Button 
																		link={true}
																		size="sm"
																		color="blue"
																		// component={Link}
																		weight={600}
																		// to={`/pages/${page_id}/components/${item?.id}/edit`}
																		onClick={ () => editIncidentUpdate({ incident_update_id : update?.id }) }
																		mr={5}
																		>Edit</Button>
																	<Button 
																		link={true}
																		size="sm"
																		color="red"
																		weight={600}
																		onClick={() => openModal_deleteIncidentUpdate({ incident_update_id : update?.id })} 
																		>Delete</Button>
																</div>
																<p  color="dimmed" size="sm">{update?.description}</p>
																<span className="date" mt={4}>{moment(update?.updated_at).format('dddd, MMMM Do YYYY, h:mm A')}</span>
															</Timeline.Item>
														)
													})
												} 
										</Timeline>
										
									)
								}
							</div>
						</div>
					</div>
					
				</div>
		</Main>
		</>
	)
}

